import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import momentTimezone from 'moment-timezone';

import AddTablesForm from '../AddTablesForm/AddTablesForm';
import CreateEventDropdown from '../CreateEventDropdown/CreateEventDropdown';

const makeEvent = (name, type, weddingDate) => {
  return {
    name,
    type,
    date: moment.utc(weddingDate),
    timezone: momentTimezone.tz.guess(),
    start_at: '2021-01-11T18:00:00Z',
    public: true,
    collect_rsvps: undefined,
    country_code: 'US',
    end_at: null,
    end_time: null,
  };
};

const CreateEventForm = ({ eventTypes, createEventWithChart, weddingDate }) => {
  const [selectedType, setSelectedType] = useState(eventTypes[0]);
  const handleSelection = event => setSelectedType(event);
  const handleCreateChart = tables => {
    const { title, value } = selectedType;
    createEventWithChart(makeEvent(title, value, weddingDate), tables);
  };

  return (
    <div className="seating-create-modal">
      <h1 className="h1">Welcome to Your Seating Chart!</h1>
      <p className="create__subtitle">
        We&apos;ll add you to the first table. Add some other tables to get started!
      </p>
      <div className="create__form">
        <CreateEventDropdown eventTypes={eventTypes} onSelect={val => handleSelection(val)} />
        <AddTablesForm createChart={handleCreateChart} />
      </div>
    </div>
  );
};

CreateEventForm.propTypes = {
  eventTypes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
    })
  ).isRequired,
  createEventWithChart: PropTypes.func.isRequired,
  weddingDate: PropTypes.string.isRequired,
};

export default CreateEventForm;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/ChartCreator/CreateEventForm/CreateEventForm.jsx